let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3heg4")).then(() => parcelRequire('9CIPb'));